<div class="reembolsos">
  <!-- Request -->
  <div class="card reembolso">
    <h5 class="title">{{ title }}</h5>
    <div class="input-box reembolso">
      <div class="campos-cont">
        <app-campos
          [tipo]="'reembolsos'"
          [camposVisibles]="['tipoDocumentoIdentificacion']"
          (filterChange)="onFilterChange($event)"
          (onClear)="onClearFields()"
        ></app-campos>
      </div>
    </div>
  </div>


  @if (reembolsoData && (reembolsoData.PolicyInformation &&
  reembolsoData.PolicyInformation.length > 0 ||
  reembolsoData.CustomerInformation && reembolsoData.CustomerInformation.length
  > 0)) {
  <form>
    <!-- Formulario -->
    <div class="card-reembolso-form mt-3">
      <div class="card info">
        <h5 class="title">Datos del procedimiento</h5>

        <div class="info-grid">
          <!-- Row 1 -->
          @if(reembolsoData.PolicyTitular && reembolsoData.PolicyTitular.length
          > 1) {
          <div class="input-box poliza">
            <label for="poliza">Póliza</label>
            <select
              id="poliza"
              class="input-field"
              [(ngModel)]="selectedPolicy"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFieldsDisabled"
              (change)="onSelectedPolicy(selected.value)"
              #selected
            >
              <option value="" selected hidden>Seleccione póliza</option>

              @for (titular of reembolsoData.PolicyTitular; track titular) {
              <option [value]="titular.PolicyNumber">
                {{ titular.PolicyNumber }}
              </option>
              }
            </select>
          </div>
          } @else{
          <div class="input-box poliza">
            <label for="poliza">Póliza</label>
            <input
              type="text"
              value="{{ reembolsoData.PolicyTitular?.[0]?.PolicyNumber }}"
              id="poliza"
              class="input-field"
              placeholder="No. de póliza"
              disabled
            />
          </div>
          }

          <div class="input-box origen-reclamacion">
            <label for="origen-reclamacion">Origen de reclamación</label>
            <select
              name="origen-reclamacion"
              id="origin-input"
              class="input-field select-field w-100"
              [(ngModel)]="selectedOrigin"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFieldsDisabled"
              required
            >
              <option value="" hidden>Seleccione origen</option>
              <option
                *ngFor="let origin of claimOriginLocations"
                [value]="origin.Code"
              >
                {{ origin.description }}
              </option>
            </select>
          </div>

          <div class="input-box paciente-asegurado">
            <label for="paciente">Nombre del paciente asegurado</label>
            <select
              id="paciente"
              class="input-field select-field w-100"
              [(ngModel)]="selectedPatient"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFieldsDisabled"
              (change)="onSelectedPatient(selected.value)"
              #selected
              placeholder="Seleccione paciente asegurado"
              required
            >
              <option value="" hidden>Seleccione paciente asegurado</option>
              @for (patient of filteredCustomerName; track patient) {
              <option [value]="patient">
                {{ patient }}
              </option>
              }
            </select>
          </div>

          <!-- Row 2 -->

          <div class="input-box listado-servicios">
            <label for="servicios">Lista de servicios</label>
            <select
              name="servicios"
              id="servicios"
              class="input-field select-field w-100"
              [(ngModel)]="selectedProcedure"
              [ngModelOptions]="{ standalone: true }"
              (change)="setServicioName()"
              required
            >
              <option value="" hidden>Seleccione el servicio</option>

              @for (servicio of reembolsoData.MedicalTreatment; track
              servicio; let index = $index) {
              <option value="{{ servicio.OCode }}">
                {{ servicio.StringData }}
              </option>
              }

            </select>
          </div>

          <div class="input-box fecha-prestacion-servicio">
            <label for="fecha-servicio">Fecha de prestación de servicio</label>
            <div class="date-input">
              <input
                type="date"
                id="fecha-servicio"
                class="input-field date-input"
                placeholder=""
                [max]="today"
                [(ngModel)]="fechaServicio"
                [ngModelOptions]="{ standalone: true }"
                name="fechaServicio"
              />
            </div>
          </div>

          <div class="inputs-monto">
            <div class="input-box currency">
              <label for="currency">Moneda</label>
              <select
                name="currency"
                id="currency-input"
                (change)="setCurrencyCode()"
                class="input-field"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="selectedCurrency"
                [disabled]="isFieldsDisabled"
              >
                <option value="" selected hidden>Seleccione moneda</option>
                @for (currency of reembolsoData.CurrencyInformation; track
                currency ; let index = $index) {
                <option value="{{ currency.CurrencyCode }}">
                  {{ currency.CurrencyName }}
                </option>
                }
              </select>
            </div>

            <div class="input-box monto">
              <label for="monto">Monto</label>
              <input
                type="text"
                id="monto"
                class="input-field"
                placeholder="Monto"
                [(ngModel)]="monto"
                (input)="handleMontoInput($event)"
                name="monto"
              />
            </div>
          </div>
        </div>
        <button
          class="btn-s-new agregar-servicio"
          (click)="agregarServicio()"
          [disabled]="!isFormValid()"
        >

          Agregar servicio
        </button>
      </div>

      <hr />
      <!-- Resumen -->
      @if(hasServicio) {
      <div class="resumen-servicios-container">
        <div class="input-box resumen-servicios">
          <label class="resumen-servicio-label" for="resumen-servicio"

            >Resumen de servicios añadidos</label
          >
          <div class="resumen-container">
            @for(servicio of servicios; track $index) {
            <div class="servicio-item">
              <button class="close-btn" (click)="eliminarServicio($index)">
                <i class="bi bi-x"></i>

              </button>
              <div class="servicio-detalle">
                <p>
                  <strong>Servicio {{ $index + 1 }}</strong
                  >: {{ servicio.nombre }}

                </p>
                <p>
                  <strong>Fecha:</strong>
                  {{ servicio.fecha.split("-").reverse().join("/") }}
                </p>
                <p>

                  
                  <strong>Monto:</strong> {{ servicio.codigo }}${{
                    servicio.monto
                  }}
                </p>

              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </form>



  <!-- Información de pago -->
  <div class="card informacion-pago mt-3">
    <h5 class="title">Informaciónes de pago</h5>
    <div class="info-pago-grid">
      <form>
        <div class="input-box forma-pago-container">
          <div class="input-box forma-pago">
            <label for="forma-pago">Forma de pago</label>
            <select
              type="text"
              [(ngModel)]="selectedPaymentType"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="!isFieldsDisabled"
              id="forma-pago"
              class="select-field"
              (change)="handlePaymentTypeChange(selectedPaymentType)"
            >
              <option value="">Seleccione la forma de pago</option>
              @for (forma of reembolsoData.TypeOfRefundInformation; track
              forma;let index = $index) {
              <option value="{{ forma.code }}">{{ forma.description }}</option>
              }
            </select>
          </div>

          @if(selectedPaymentType === '2') {
          <div class="cheque-text-container">
            <p class="cheque-text">
              El cheque será emitido a nombre de
              {{reembolsoData.PolicyTitular?.[0]?.Name}}.
              <span class="cheque-text-info">ℹ️</span>
            </p>
          </div>
          }
        </div>

        @if(selectedPaymentType === '1') {
        <div class="input-box banco">
          <label for="banco">Banco</label>
          <select
            id="banco"
            class="select-field"
            [(ngModel)]="selectedBank"
            [ngModelOptions]="{ standalone: true }"
            (change)="onSelectedBank(selected.value)"
            #selected
          >
            @if(AccountCurrencyExist) {
            <option value="" selected hidden>Seleccione un banco</option>
            @for (banco of reembolsoData.ClientAccount; track banco;let index =
            $index) {
            <option value="{{ banco.BankCode }}">{{ banco.BankName }}</option>
            } } @if(!AccountCurrencyExist) {
            <option value="" selected hidden>Seleccione un banco</option>
            @for (banco of reembolsoData.BankInformation; track banco) {
            <option value="{{ banco.BankCode }}">{{ banco.BankName }}</option>
            } }
          </select>
        </div>

        <div class="input-box numero-cuenta">
          <label for="numero-cuenta">Numero de cuenta</label>
          <div class="custom-datalist-container">
            <input
              type="text"
              id="numero-cuenta"
              class="input-field"
              placeholder="Numero de cuenta"
              [(ngModel)]="accountNumber"
              [ngModelOptions]="{ standalone: true }"
              pattern="[0-9]*"
              list="cuentas-list"
            />
            @if(AccountCurrencyExist) {
            <datalist id="cuentas-list">
              @for (cuenta of accountsList; track cuenta ; let index = $index) {
              <option [value]="cuenta.AccountNumber">
                {{ cuenta.AccountNumber }} - {{ cuenta.BankName }}
              </option>
              }
            </datalist>
            }
          </div>
        </div>

        @if(reembolsoData.ClientAccount?.length) {
        <div class="input-box tipo-cuenta">
          <label for="tipo-cuenta">Tipo de cuenta</label>
          <select
            id="tipo-cuenta"
            class="select-field"
            [(ngModel)]="selectedAccountType"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="" selected hidden>Seleccione tipo de cuenta</option>
            @for (tipo of filteredClientAccountType; track tipo) {
            <option value="{{ tipo }}">
              {{ tipo === "C" ? "Corriente" : "Ahorro" }}
            </option>
            }
          </select>
        </div>
        } @if(!AccountCurrencyExist) {
        <div class="input-box tipo-cuenta">
          <label for="tipo-cuenta">Tipo de cuenta</label>
          <select
            id="tipo-cuenta"
            class="select-field"
            [(ngModel)]="selectedAccountType"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="" selected hidden>Seleccione tipo de cuenta</option>
            @for (tipo of reembolsoData.TypeOfBankAccountInformation; track
            tipo;let index = $index) {
            <option value="{{ tipo.code }}">{{ tipo.description }}</option>
            }
          </select>
        </div>
        }
        <div class="input-box moneda-cuenta">
          <label for="moneda-cuenta">Moneda de la cuenta</label>
          <select
            id="moneda-cuenta"
            class="select-field"
            [(ngModel)]="selectedCurrency"
            [disabled]="true"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="" selected hidden>
              Seleccione moneda de la cuenta
            </option>
            @for (moneda of reembolsoData.CurrencyInformation; track moneda;let
            index = $index) {
            <option value="{{ moneda.CurrencyCode }}">
              {{ moneda.CurrencyName }}
            </option>
            }
          </select>
        </div>
        @if(reembolsoData.ClientAccount?.length) {
        <div class="input-box nueva-cuenta">
          <div class="checkbox-container">
            <input
              type="checkbox"
              id="nuevaCuenta"
              [(ngModel)]="isNuevaCuenta"
              (change)="onNuevaCuentaChange()"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="nuevaCuenta">Agregar nueva cuenta</label>
          </div>
        </div>
        } }
      </form>
    </div>
  </div>

  <!-- Documentos requeridos -->
  <div class="card documentos-requeridos mt-3">
    <div class="card-title">
      <h5 class="title">
        Documentos requeridos
        <span class="info-icon info-data">ℹ️</span>
      </h5>
      <p>
        Total de archivos cargados:
        {{ fileHandler.formatFileSize(fileHandler.getTotalFileSizeInBytes()) }}
        de 25 mb
      </p>
    </div>
    <form>
      <div class="input-box documentos-requeridos">
        <input
          type="file"
          #fileInput
          class="input-field-documentos"
          (change)="onFileSelected($event)"
          multiple
        />
        <button
          class="button-upload"
          id="documentos"
          (click)="triggerFileInput($event)"
        >
          <i class="bi bi-file-earmark-arrow-up"></i>
          Click aqui para cargar archivos
        </button>
      </div>

      <!-- Muestra los archivos seleccionados -->
      @if (selectedFiles.length > 0) {
      <div class="selected-files">
        @for (file of selectedFiles; track file; let index = $index) {
        <div class="file-item">
          <div class="file-info">
            <i class="bi bi-file-earmark-text"></i>
            <span class="file-name"
              >{{ file.name }} ({{
                fileHandler.formatFileSize(file.size)
              }})</span
            >
          </div>
          <button class="remove-file" (click)="fileHandler.removeFile(index)">
            <i class="bi bi-x"></i>
          </button>
        </div>
        }
      </div>
      }
    </form>
    <hr />
    <div class="mt-3 enviar-reembolso">
      <button
        (click)="submitReembolso()"
        class="btn-m-new"
        [disabled]="!isSubmitEnabled()"
      >
        Enviar
      </button>
    </div>
  </div>

  <!-- Enviar -->

  } else @if (hasSearched && (reembolsoData === undefined ||
  (!reembolsoData.PolicyInformation?.length &&
  !reembolsoData.CustomerInformation?.length ))) {
  <div class="card reembolso-card mt-2">
    <div class="reembolso-no-data">No hay datos de la póliza</div>
  </div>
  }
</div>

@if (showConfirmModal) {
<div class="request-notification-modal">
  <div class="modal-container">
    <div class="modal-title">
      <h5>Confirmar eliminación</h5>
      <span>¿Estás seguro que deseas eliminar este servicio?</span>
    </div>
    <div class="modal-actions">
      <button class="button-main" (click)="confirmarEliminacion()">

        Aceptar
      </button>
      <button class="button-secundary" (click)="cancelarEliminacion()">
        Cancelar
      </button>
    </div>
  </div>
</div>
} @if (showMessageModal) {
<div class="request-notification-modal">
  <div class="modal-container">
    <img src="assets/checked.svg" alt="" />
    <h3 class="mb-4"><strong>Solicitud de reembolso enviada</strong></h3>
    <p>
      Su solicitud ha sido debidamente completada bajo el No.
      <strong>{{ claimNumber }}</strong
      >, estará recibiendo respuesta en las próximas 48 horas laborables
    </p>
    <button (click)="closeMessageModal()" class="btn-m-new mt-3">Cerrar</button>
  </div>
</div>
}
<!-- Notificacion -->

<app-notification
  [show]="showNotification"
  [type]="notificationType"
  [title]="notificationTitle"
  [message]="notificationMessage"
></app-notification>
